<template>
    <div>
        <p class="version">v1.0.0.0818.0</p>
    </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {
    }
  },
  mounted(){

  }
}
</script>

<style scoped>
.version{
    position: absolute;
    bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/index.vue